import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { teceoGrayBackground } from '../Theme';
import { ROOT_PAGE_PADDING } from '../utils/constants';

export const APP_BAR_ID = 'measures--app-bar';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    backgroundColor: teceoGrayBackground,
    padding: ROOT_PAGE_PADDING,
    height: '100%',
    paddingBottom: 0,
    paddingTop: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  paddingTopToFilterV2: {
    paddingTop: 0,
  },
}));

export const useRootStyles = () => useStyles();
